interface IsSupported {
  checkVisibility: boolean
}

export const isSupported: IsSupported = {
  checkVisibility:
    typeof document.createElement('div').checkVisibility === 'function',
}
